import React, { useState } from 'react';
import { useSchoolClassesConfigHook } from '../../../common/hooks/useSchoolClassesConfig';
import DialogModal from '../../../../components/DialogModal';
import { StyledButton } from '../../styled';
import { Box, CircularProgress, Typography } from '@mui/material';
import pallet from '../../../../layouts/pallet';
import Icons from '../../../../components/icons';
import DropdownSelect from '../../../../components/DropdownSelect';
import { useFeeStructureContext } from '../../context/FeeStructureContext';

const ClonePaymentOptionForm = ({
  open,
  onClose,
  handlePaymentSchemeClone
}: {
  open: boolean;
  onClose: () => void;
  handlePaymentSchemeClone: ({
    academicYearToCloneFrom,
    gradeToCloneFrom
  }: {
    academicYearToCloneFrom: string;
    gradeToCloneFrom: string;
  }) => Promise<void>;
}) => {
  const { selectedAcademicYear, selectedGrade, academicYears, admissionType } =
    useFeeStructureContext();
  const [academicYearToCloneFrom, setAcademicYearToCloneFrom] =
    useState<string>('');
  const [gradeToCloneFrom, setGradeToCloneFrom] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { gradeOptions } = useSchoolClassesConfigHook();

  const handleModalClose = () => {
    setAcademicYearToCloneFrom('');
    setGradeToCloneFrom('');
    onClose();
  };
  const handleClonePaymentScheme = async () => {
    setIsSubmitting(true);
    await handlePaymentSchemeClone({
      academicYearToCloneFrom,
      gradeToCloneFrom
    });
    setIsSubmitting(false);
    onClose();
  };
  return (
    <DialogModal
      open={open}
      onClose={handleModalClose}
      title='Clone Payment Option'
      actions={
        <StyledButton
          onClick={handleClonePaymentScheme}
          disabled={
            isSubmitting || !academicYearToCloneFrom || !gradeToCloneFrom
          }
        >
          {isSubmitting ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Clone'
          )}
        </StyledButton>
      }
    >
      <Box
        sx={{
          backgroundColor: pallet.yellowBackground,
          padding: '12px 16px',
          display: 'flex',
          gap: '12px',
          borderRadius: '6px',
          marginBottom: '16px'
        }}
      >
        <Icons.AlertYellowFilled />
        <Box>
          <Typography color={pallet.yellowAlertText}>** Note</Typography>
          <Typography sx={{ marginTop: '4px' }} color={pallet.yellowAlertText}>
            You are cloning{' '}
            {admissionType === 'rollover' ? 'rollover' : 'new admission'}{' '}
            payment options for {selectedAcademicYear} of grade {selectedGrade}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'start', gap: '16px' }}>
        <DropdownSelect
          label='Academic Year'
          placeholder='Select Academic Year'
          name='academicYear'
          value={academicYearToCloneFrom}
          options={academicYears}
          onChange={(event) => {
            setAcademicYearToCloneFrom(event.target.value as string);
          }}
          hasTopLabel
          hintText={academicYearToCloneFrom ? '' : 'This is required field*'}
        />
        <DropdownSelect
          label='Grade'
          placeholder='Select Grade'
          name='grade'
          value={gradeToCloneFrom}
          options={gradeOptions}
          onChange={(event) => {
            setGradeToCloneFrom(event.target.value as string);
          }}
          hasTopLabel
          hintText={gradeToCloneFrom ? '' : 'This is required field*'}
        />
      </Box>
    </DialogModal>
  );
};

export default ClonePaymentOptionForm;
